Beacon.GenericPageInitialization = function () {

    $(function () {
        Beacon.Tabs.initialize_generic();

        try {
            Beacon.TabularDataSupport.init();
        } catch (ex) {
        }

        
        try {
            // enable tooltip wrappers 
            $('.tooltip-wrapper').tooltip();
        }
        catch (ex) {
        }

        try {
            Beacon.WCAG.initialize();
        } catch (ex) {
        }

        // support for logout button
        $("#btnLogOut").click(function () {
            $("form#logoutForm").submit();
        });

    });

};

